export default __webpack_public_path__ + "static/media/indent-increase.2a082ada.svg";